export class Accordion {
  private element: HTMLElement;
  private details: NodeListOf<HTMLDetailsElement>;
  private accordionContent: HTMLElement | null;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.details = this.element.querySelectorAll("details");
      this.accordionContent = this.element.querySelector(".accordion__content");
      this.init();
    }
  }

  private init() {
    this.animateOlderBrowsers();
  }

  private animateOlderBrowsers() {
    // Code for browsers that don't support interpolate-size
    if (!CSS.supports("interpolate-size", "allow-keywords")) {
      this.details.forEach((detail) => {
        const accordionContent = detail.querySelector(".accordion__content");
        detail.addEventListener("click", (e) => {
          if ((e.target as HTMLElement).closest("a")) return;
          accordionContent?.classList.toggle("accordion__content--open");
          if (detail.hasAttribute("open")) {
            e.preventDefault();
            accordionContent?.addEventListener(
              "transitionend",
              () => {
                detail.removeAttribute("open");
              },
              { once: true },
            );
          }
        });
      });
    }
  }
}

export default function accordionInit() {
  const accordions = document.querySelectorAll(
    ".accordion",
  ) as NodeListOf<HTMLElement>;
  for (let i = 0; i < accordions.length; i++) {
    new Accordion(accordions[i]);
  }
}
